/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Pipe, PipeTransform} from '@angular/core';
import {PrettyPrintUpdatedByPipe} from '../../../../shared/pipes/pretty-print-updated-by/pretty-print-updated-by.pipe';

@Pipe({
    name: 'prettyPrintClosedBy',
    standalone: false
})
export class PrettyPrintClosedByPipe implements PipeTransform {

    transform(cellValue: { username: string, email: string }): string {
        let value = null;
        if (cellValue != null) {
            if (cellValue?.username === 'system') {
                value = `Orcan system`;
            } else {
                value = PrettyPrintUpdatedByPipe.prototype.transform(cellValue);
            }
        }
        return value;
    }
}

